import { NotFound } from "@ecologi/react-components/src/NotFound";

export async function getStaticProps() {
  return {
    props: {
      layoutProps: {
        isLightHeader: true,
      },
    },
  };
}

export default NotFound;
